import { Box } from '../Common/Box';
import { PaymentMethodEnum } from '@/types/common';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const PixPayBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);
  return (
    <Box
      isSelected={paymentMethodSelected === PaymentMethodEnum.PIX}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.PIX)}
    >
      <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.PIX)} alt="pix" />
    </Box>
  );
};
